import { Box, SxProps, Typography } from "@mui/material";
import { useThemeColor } from "../hooks/useThemeColor";
import { useOnEscapeKeyDown } from "../hooks/useOnEscapeKeyDown";

export function LabeledBox(
  props: React.PropsWithChildren<{
    label: string;
    sx?: SxProps;
    fullWidth?: boolean;
    onClose?: () => void;
  }>,
) {
  const { label, sx, fullWidth, onClose, children } = props;
  const primaryColor = useThemeColor("primary");
  useOnEscapeKeyDown(onClose);

  return (
    <Box
      sx={{
        position: "relative",
        mt: "14px",
        border: `1.6px solid ${primaryColor.main}`,
        borderRadius: "8px",
        ...(fullWidth ? { width: "100%" } : {}),
        ...sx,
      }}
    >
      <Box sx={{ position: "absolute", top: "-14px", left: "8px", backgroundColor: "background.paper" }}>
        <Typography variant="caption" sx={{ px: 1, color: primaryColor.main }}>
          {label}
        </Typography>
      </Box>
      <Box sx={{ mt: "10px" }}>{children}</Box>
    </Box>
  );
}
